import React, { FC, PropsWithChildren } from 'react';
import './AdminToolbarTitle.scss';

export const AdminToolbarTitle: FC<PropsWithChildren> = ({ children }) => {
  return <h1 className="AdminToolbarTitle">{children}</h1>;
};
